import { render, staticRenderFns } from "./compManageDetail.vue?vue&type=template&id=0f728864&scoped=true"
import script from "./compManageDetail.vue?vue&type=script&lang=js"
export * from "./compManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f728864",
  null
  
)

export default component.exports